/*
  Trickcal: Chibi Go Catalog - Full UI Integration
  - API Pattern: GET-based (similar to wuwa02, same API owner)
  - Character endpoint: http://n.mxwy.ltd/api/card/?game=嘟嘟脸恶作剧&tag=三星
  - Search endpoint: http://n.mxwy.ltd/api/deck/?cards={ids}&game=嘟嘟脸恶作剧&...
  - Cards parameter: pipe-separated with repeats (e.g., 17600|17632|17600)
  - Normalizes ddl6_ prefix from character names
  - Filters out server cards (ddl_初始号, ddl_欧美, etc.) from display
  - Parses source field for account details
  - Proxy: Vercel bssy-mxwy-proxy (replaced corsproxy.io)
  - Shared utils: catalog-utils.js (escapeHtml, toast, clipboard, ID obfuscation)
*/
(function(){
  /* ====== API Sources Declaration ====== */
  const API_SOURCES = {
    'trickcal': { name: 'Trickcal API', enabled: true }
  };
  
  const escapeHtml = GachaUtils.escapeHtml;
  
  // API endpoints - Using Vercel proxy (same as wuwa-v7/v8)
  const PROXY_BASE = 'https://nodejs-serverless-function-express-delta-ten-11.vercel.app/api/wuwa-multi-proxy';
  const TRICKCAL_CHARS_API = PROXY_BASE + '?source=mxwy&url=' + encodeURIComponent('http://n.mxwy.ltd/api/card/?game=嘟嘟脸恶作剧&tag=三星');
  const TRICKCAL_SEARCH_BASE = 'http://n.mxwy.ltd/api/deck/';
  
  let selected = {};
  let characterList = [];
  let characterMap = {}; // Map ID to character data
  
  // Pagination state
  let allFilteredAccounts = []; // All accounts currently displayed
  let currentPage = 0; // Last page we fetched
  let totalPages = 0; // Total pages available from API
  let currentSearchParams = null; // Store search params for continuation
  let currentSelectedServer = ''; // Store selected server for continuation
  let isLoadingMore = false; // Prevent multiple simultaneous loads
  const ACCOUNTS_PER_BATCH = 24; // Accounts to fetch per API batch
  let allSearchResults = [];
  let renderedCount = 0;
  const BATCH_SIZE = 24;
  let resultObserver = null;
  let hasMoreApiPages = false;
  
  // Settings & Translations Initialization
  var trickcalSettings = GachaUtils.parseSettings('catalog-trickcal-settings');
  
  // console.log('[Trickcal] Raw settings from Liquid:', trickcalSettings);
  // console.log('[Trickcal] API toggles received:', trickcalSettings.api_toggles);
  
  // Override API_SOURCES enabled state from admin settings
  if (trickcalSettings.api_toggles) {
    Object.keys(API_SOURCES).forEach(apiId => {
      const oldState = API_SOURCES[apiId].enabled;
      if (trickcalSettings.api_toggles.hasOwnProperty(apiId)) {
        API_SOURCES[apiId].enabled = trickcalSettings.api_toggles[apiId] === true;
        // console.log(`[Trickcal] API '${apiId}': ${oldState} → ${API_SOURCES[apiId].enabled} (admin setting: ${trickcalSettings.api_toggles[apiId]})`);
      }
    });
  }
  
  // console.log('[Trickcal] ═══════════════════════════════════════════');
  // console.log('[Trickcal] FINAL API SOURCES STATUS:');
  Object.entries(API_SOURCES).forEach(([id, api]) => {
    // console.log(`[Trickcal]   ${id}: ${api.enabled ? '✅ ENABLED' : '❌ DISABLED'} (${api.name})`);
  });
  // console.log('[Trickcal] ═══════════════════════════════════════════');
  
  const enableApiCalls = API_SOURCES.trickcal.enabled;

  var nameTranslationsMap = GachaUtils.buildTranslationMap(trickcalSettings.translations_json);
  var customImagesMap = GachaUtils.buildImageMap(trickcalSettings.images_json);

  // Name normalization: strip ddl6_ prefix
  const normalizeName = name => {
    if (!name) return name;
    return name.startsWith('ddl6_') ? name.slice(5) : name;
  };
  
  var privateToPublicID = function(id) {
    if (!id) return '';
    return GachaUtils.obfuscateIdV2(id, '__', 'TR');
  };
  
  // Translation helper function
  const translateName = name => {
    const normalized = normalizeName(name);
    const translated = nameTranslationsMap[normalized] || nameTranslationsMap[name] || normalized;
    return translated;
  };
  
  // Custom image helper function
  const getCustomImage = name => {
    const normalized = normalizeName(name);
    return customImagesMap[normalized] || customImagesMap[name] || null;
  };
  
  // Server card IDs mapping
  const SERVER_CARDS = {
    17630: 'Asia',
    17632: 'Global',
    17633: 'TW/HK/MO' // Filter out this server
  };
  
  // Detect server from card IDs in account
  const detectServerFromCards = (cards) => {
    if (!cards || !Array.isArray(cards)) return 'Unknown';
    
    for (const card of cards) {
      if (SERVER_CARDS[card.id]) {
        return SERVER_CARDS[card.id];
      }
    }
    return 'Unknown';
  };
  
  // Server translation helper (kept for backward compatibility)
  const translateServer = (serverStr) => {
    if (!serverStr) return 'Unknown';
    if (serverStr.includes('国际服')) return 'Global';
    if (serverStr.includes('美洲')) return 'America';
    if (serverStr.includes('欧洲')) return 'Europe';
    if (serverStr.includes('亚洲')) return 'Asia';
    return serverStr;
  };
  
  // Parse source field to extract account details
  // Example: "国际服   安卓 嘟嘟脸恶作剧    昵称:Aria   水晶叶:30   抽卡券:30   新手招募券:50   更新时间:2025-10-20 01:52:38    LCH"
  const parseSource = (source) => {
    if (!source) return {};
    
    const result = {
      server: '',
      platform: '',
      nickname: '',
      crystalLeaves: '',
      gachaCoupons: '',
      beginnerCoupons: '',
      updateTime: ''
    };
    
    // Extract server (国际服, etc.)
    const serverMatch = source.match(/(国际服|美洲|欧洲|亚洲)/);
    if (serverMatch) result.server = translateServer(serverMatch[1]);
    
    // Extract platform (安卓, iOS, etc.)
    const platformMatch = source.match(/(安卓|iOS|PC)/);
    if (platformMatch) result.platform = platformMatch[1];
    
    // Extract nickname
    const nicknameMatch = source.match(/昵称[:：]([^\s]+)/);
    if (nicknameMatch) result.nickname = nicknameMatch[1];
    
    // Extract resources
    const crystalMatch = source.match(/水晶叶[:：](\d+)/);
    if (crystalMatch) result.crystalLeaves = crystalMatch[1];
    
    const gachaMatch = source.match(/抽卡券[:：](\d+)/);
    if (gachaMatch) result.gachaCoupons = gachaMatch[1];
    
    const beginnerMatch = source.match(/新手招募券[:：](\d+)/);
    if (beginnerMatch) result.beginnerCoupons = beginnerMatch[1];
    
    // Extract update time
    const timeMatch = source.match(/更新时间[:：]([^\s]+\s+[^\s]+)/);
    if (timeMatch) result.updateTime = timeMatch[1];
    
    return result;
  };
  
  // Filter out server/system cards (cards that start with ddl_ but not ddl6_)
  const isServerCard = (name) => {
    if (!name) return false;
    return name.startsWith('ddl_') && !name.startsWith('ddl6_');
  };

  var updateSelectedUI = function() { GachaUtils.updateSelectedUI(selected); };
  
  // Scroll to results section for better UX
  const scrollToResults = GachaUtils.scrollToResults;
  
  function updateThumbDisplay(thumb, id) {
    GachaUtils.updateThumbDisplay(thumb, selected[id]?.count || 0);
  }
  
  function clearSelection() {
    selected = {};
    document.querySelectorAll('.thumb').forEach(thumb => {
      thumb.classList.remove('selected');
      const badge = thumb.querySelector('.count-badge');
      if (badge) badge.remove();
    });
    updateSelectedUI();
    document.querySelector("#results").innerHTML = '';
    allSearchResults = [];
    renderedCount = 0;
  }
  
  var showToast = GachaUtils.showToast;
  var hideToast = GachaUtils.hideToast;
  
  var copyToClipboard = function(text) {
    GachaUtils.copyToClipboard(text, 'ID copied! Please share this with customer service to get price quotation.');
  };
  
  const initResultObserver = () => {
    if (resultObserver) resultObserver.disconnect();
    resultObserver = GachaUtils.createSentinelObserver({
      hasMoreBatch: function() { return renderedCount < allSearchResults.length; },
      hasMoreApi: function() { return hasMoreApiPages && !isLoadingMore; },
      onBatch: function() { renderBatch(); },
      onLoadMore: function() { loadMoreAccounts(); }
    });
  };

  const initPriceModal = () => GachaUtils.initPriceModal({ copyToClipboard });
  window.showPriceCheck = GachaUtils.showPriceCheck;

  function renderFilterUI() {
    const container = document.querySelector("#filters");
    if (!container) return;
    container.innerHTML = '';
    if (!characterList.length) {
      container.innerHTML = '<div class="no-data">No character data.</div>';
      return;
    }
    
    // Filter out server cards from display
    const displayChars = characterList.filter(char => !isServerCard(char.name));
    
    displayChars.forEach(char => {
      const thumb = document.createElement('div');
      thumb.className = 'thumb';
      thumb.dataset.id = char.id;
      
      // Apply translation and custom image
      const displayName = translateName(char.name);
      const customImg = getCustomImage(char.name);
      const displayImg = customImg || char.role_img;
      
      thumb.innerHTML = `
        <div class="thumb-img-container">
          <img alt="${escapeHtml(displayName)}" src="${escapeHtml(displayImg)}" loading="lazy"/>
        </div>
        <div class="label">${escapeHtml(displayName)}</div>
      `;
      thumb.onclick = () => {
        const id = thumb.dataset.id;
        if (selected[id]) {
          selected[id].count++;
        } else {
          selected[id] = { count: 1, name: displayName, img: displayImg, originalName: char.name };
        }
        updateThumbDisplay(thumb, id);
        updateSelectedUI();
      };
      container.appendChild(thumb);
    });
    updateSelectedUI();
  }
  
  function loadResources() {
    // Show API status banner if disabled
    const disabledApis = Object.entries(API_SOURCES).filter(([id, api]) => !api.enabled).map(([id, api]) => api.name);
    if (disabledApis.length > 0) {
      // console.log('[Trickcal] Some APIs are disabled - showing warning banner');
      const searchSection = document.querySelector("#trickcal");
      if (searchSection) {
        const banner = document.createElement('div');
        banner.style.cssText = 'background: #fef3c7; border: 2px solid #f59e0b; border-radius: 8px; padding: 12px 16px; margin: 16px 0; color: #92400e; font-weight: 500; text-align: center;';
        banner.innerHTML = `⚠️ API calls are currently disabled. Search functionality is temporarily unavailable. Please contact Gachamacha support for assistance.`;
        searchSection.insertBefore(banner, searchSection.firstChild);
      }
    }
    
    if (!enableApiCalls) {
      // console.log('[Trickcal] ❌ Skipping Trickcal API (disabled)');
      const container = document.querySelector("#filters");
      if (container) container.innerHTML = '<div class="no-data">⚠️ API calls are currently disabled.<br><br>Please contact Gachamacha support for assistance.</div>';
      return;
    }
    
    // console.log('[Trickcal] ✅ Loading Trickcal API');
    // console.log('[Trickcal] API URL:', TRICKCAL_CHARS_API);
    
    fetch(TRICKCAL_CHARS_API)
      .then(r => {
        // console.log('[Trickcal] Fetch response status:', r.status, r.statusText);
        // console.log('[Trickcal] Response headers:', {
        //   contentType: r.headers.get('content-type'),
        //   corsHeaders: r.headers.get('access-control-allow-origin')
        // });
        if (!r.ok) {
          throw new Error(`HTTP ${r.status}: ${r.statusText}`);
        }
        return r.json();
      })
      .then(payload => {
        // console.log('[Trickcal] Raw API response:', payload);
        // console.log('[Trickcal] Response type:', typeof payload, 'Is array:', Array.isArray(payload));
        
        characterList = Array.isArray(payload) ? payload : [];
        // console.log(`[Trickcal] Loaded ${characterList.length} characters from API`);
        
        // if (characterList.length > 0) {
          // console.log('[Trickcal] First character sample:', characterList[0]);
          // console.log('[Trickcal] Character structure:', {
        //     id: characterList[0]?.id,
        //     name: characterList[0]?.name,
        //     role_img: characterList[0]?.role_img,
        //     weight: characterList[0]?.weight
        //   });
        // }
        
        // Build character map for quick lookup
        characterList.forEach(char => {
          characterMap[char.id] = char;
        });
        
        renderFilterUI();
      })
      .catch(err => {
        console.error("[Trickcal] Filter load failed:", err);
        console.error("[Trickcal] Error details:", {
          message: err.message,
          stack: err.stack,
          name: err.name
        });
        const container = document.querySelector("#filters");
        if (container) container.innerHTML = '<div class="no-data">Failed to load character list. Please refresh the page.</div>';
      });
  }
  
  // Fetch pages incrementally until we have enough filtered results
  async function fetchNextBatch(baseParams, selectedCardIds, selectedServerCardId, targetCount, isLoadMore = false) {
    const filteredAccounts = [];
    let lastPage = currentPage;
    let totalPagesAvailable = 0;
    let checkedPages = 0;
    const maxPagesToCheck = 10; // Safety limit to prevent infinite loops
    const resultsEl = document.querySelector("#results");
    
    // console.log(`[Trickcal] === Fetching next batch (target: ${targetCount} accounts, starting from page ${lastPage + 1}) ===`);
    
    while (filteredAccounts.length < targetCount && checkedPages < maxPagesToCheck) {
      lastPage++;
      checkedPages++;
      
      // Update loading message with progress
      if (resultsEl) {
        if (isLoadMore) {
          let loadingDiv = resultsEl.querySelector('#loadMoreLoading');
          if (!loadingDiv) {
            loadingDiv = document.createElement('div');
            loadingDiv.id = 'loadMoreLoading';
            loadingDiv.className = 'loading';
            resultsEl.appendChild(loadingDiv);
          }
        } else {
          resultsEl.innerHTML = '<div class="loading">Searching...</div>';
        }
      }
      
      const pageParams = new URLSearchParams(baseParams);
      pageParams.set('page', lastPage.toString());
      const baseSearchUrl = `${TRICKCAL_SEARCH_BASE}?${pageParams.toString()}`;
      const pageUrl = PROXY_BASE + '?source=mxwy&url=' + encodeURIComponent(baseSearchUrl);
      
      // console.log(`[Trickcal] Fetching page ${lastPage}...`);
      
      try {
        const response = await fetch(pageUrl);
        
        if (!response.ok) {
          console.error(`[Trickcal] Page ${lastPage} HTTP error: ${response.status} ${response.statusText}`);
          const errorText = await response.text();
          console.error('[Trickcal] Error response:', errorText);
          break;
        }
        
        const data = await response.json();
        // console.log(`[Trickcal] Page ${lastPage} raw response:`, data);
        
        // Store total pages from first response
        if (totalPagesAvailable === 0) {
          totalPagesAvailable = Math.ceil(data.count / 20) || 1; // API returns count, assume 20 per page
          // console.log(`[Trickcal] Total pages available: ${totalPagesAvailable}`);
        }
        
        const pageAccounts = data.results || [];
        // console.log(`[Trickcal] Page ${lastPage}: ${pageAccounts.length} accounts fetched`);
        
        // Filter accounts based on server
        const matchingAccounts = pageAccounts.filter(account => {
          const accountCards = account.cards || [];
          
          // Always filter out TW/HK/MO server (17633)
          const hasTWServer = accountCards.some(card => card.id === 17633);
          if (hasTWServer) {
            // console.log(`[Trickcal] Filtered out TW/HK/MO account: ${account.name}`);
            return false;
          }
          
          // If a specific server is selected, filter by that server
          if (selectedServerCardId) {
            const hasSelectedServer = accountCards.some(card => card.id === parseInt(selectedServerCardId));
            if (!hasSelectedServer) {
              const accountServer = detectServerFromCards(accountCards);
              // console.log(`[Trickcal] Filtered out account ${account.name}: Server is ${accountServer}, looking for ${SERVER_CARDS[selectedServerCardId]}`);
              return false;
            }
          }
          
          return true;
        });
        
        // console.log(`[Trickcal] Page ${lastPage}: ${matchingAccounts.length} matching accounts after filter`);
        filteredAccounts.push(...matchingAccounts);
        
        // Stop if we've reached the last page
        if (lastPage >= totalPagesAvailable) {
          // console.log('[Trickcal] Reached last page');
          break;
        }
        
        // Stop if we have enough results
        if (filteredAccounts.length >= targetCount) {
          // console.log(`[Trickcal] Target reached: ${filteredAccounts.length} >= ${targetCount}`);
          break;
        }
      } catch (err) {
        // console.error(`[Trickcal] Error fetching page ${lastPage}:`, err);
        break;
      }
    }
    
    return {
      filteredAccounts: filteredAccounts,
      lastPage: lastPage,
      totalPages: totalPagesAvailable,
      hasMore: lastPage < totalPagesAvailable
    };
  }
  
  async function performSearch() {
    const resultsEl = document.querySelector("#results");
    if (!resultsEl) return;
    if (!Object.keys(selected).length) {
      resultsEl.innerHTML = '<div class="no-data">Please select at least one character.</div>';
      return;
    }
    
    // Check if API calls are disabled
    if (!enableApiCalls) {
      // console.log('[Trickcal] API calls are disabled via admin settings');
      resultsEl.innerHTML = '<div class="no-data">⚠️ API calls are currently disabled.<br><br>Please contact Gachamacha support for assistance.</div>';
      showToast('⚠️ API calls are currently disabled', 3000);
      return;
    }
    
    // console.log('[Trickcal] ═══════════════════════════════════════════');
    // console.log('[Trickcal] SEARCH: Checking API states...');
    // console.log(`[Trickcal] Trickcal API: enabled=${API_SOURCES.trickcal.enabled}`);
    // console.log('[Trickcal] ✅ Querying Trickcal API');
    // console.log('[Trickcal] ═══════════════════════════════════════════');
    
    // Disable search button during search with spinner
    const searchBtn = document.querySelector("#searchBtn");
    if (searchBtn) {
      searchBtn.disabled = true;
      searchBtn.innerHTML = '<span style="display: inline-flex; align-items: center; gap: 8px;"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="animation: spin 1s linear infinite;"><circle cx="12" cy="12" r="10" opacity="0.25"></circle><path d="M12 2a10 10 0 0 1 10 10" stroke-linecap="round"></path></svg></span>';
    }
    
    resultsEl.innerHTML = '<div class="loading">Searching...</div>';
    
    // Build cards parameter: pipe-separated IDs with repeats
    const cardIds = [];
    Object.keys(selected).forEach(id => {
      const count = selected[id].count;
      for (let i = 0; i < count; i++) {
        cardIds.push(id);
      }
    });
    
    const cardsParam = cardIds.join('|');
    
    // Build base search parameters
    const baseParams = new URLSearchParams({
      cards: cardsParam,
      game: '嘟嘟脸恶作剧',
      limit: '',
      sourceNumberMin: '',
      sourceNumberMax: '',
      deckid: '',
      asort: 'desc'
    });
    
    // console.log('[Trickcal] Selected cards:', cardIds);
    
    // Get selected server filter
    const serverSelect = document.querySelector('#serverSelect');
    const selectedServerCardId = serverSelect ? serverSelect.value : '';
    // console.log('[Trickcal] Selected server filter:', selectedServerCardId || 'All Servers');
    
    // Scroll to results for better UX
    scrollToResults();
    
    try {
      // Reset state for new search
      currentPage = 0;
      allFilteredAccounts = [];
      currentSearchParams = baseParams;
      currentSelectedServer = selectedServerCardId;
      
      // Fetch pages incrementally until we have ACCOUNTS_PER_BATCH filtered results
      resultsEl.innerHTML = '<div class="loading">Searching...</div>';
      
      const result = await fetchNextBatch(baseParams, cardIds, selectedServerCardId, ACCOUNTS_PER_BATCH);
      
      if (result.filteredAccounts.length === 0) {
        hideToast();
        if (result.lastPage === 0) {
          resultsEl.innerHTML = '<div class="no-data">Search failed. The API may be experiencing issues. Please try again.</div>';
        } else {
          resultsEl.innerHTML = '<div class="no-data">No matching accounts found for the selected server.</div>';
        }
        return;
      }
      
      // Store results
      allFilteredAccounts = result.filteredAccounts;
      currentPage = result.lastPage;
      totalPages = result.totalPages;
      
      // console.log(`[Trickcal] Found ${result.filteredAccounts.length} matching accounts after checking ${result.lastPage} pages`);
      
      // Render results
      allSearchResults = result.filteredAccounts;
      renderedCount = 0;
      hasMoreApiPages = result.hasMore;
      renderResults();
      hideToast();
      
    } catch (err) {
      console.error('[Trickcal] Search failed:', err);
      resultsEl.innerHTML = '<div class="no-data">Search failed. Please try again.</div>';
      hideToast();
    } finally {
      // Re-enable search button
      if (searchBtn) {
        searchBtn.disabled = false;
        searchBtn.textContent = 'Search';
      }
    }
  }
  
  function renderResults() {
    const resultsEl = document.querySelector("#results");
    if (!resultsEl) return;
    resultsEl.innerHTML = '';
    if (allSearchResults.length === 0) {
      resultsEl.innerHTML = '<div class="no-data">No matching accounts found.</div>';
      return;
    }
    renderBatch();
  }

  function renderBatch() {
    const res = document.querySelector("#results");
    if (!res) return;

    const nextBatch = allSearchResults.slice(renderedCount, renderedCount + BATCH_SIZE);

    nextBatch.forEach(account => {
      const card = document.createElement("div");
      card.className = "result-card";

      const accountCards = account.cards || [];

      const detectedServer = detectServerFromCards(accountCards);
      const serverName = detectedServer || 'Global';
      const sourceInfo = parseSource(account.source);

      const cardCounts = {};
      const cardData = {};
      accountCards.forEach(card => {
        const cardId = card.id;
        if (!cardCounts[cardId]) {
          cardCounts[cardId] = 0;
          cardData[cardId] = card;
        }
        cardCounts[cardId]++;
      });

      const uniqueCards = Object.keys(cardCounts)
        .map(cardId => ({ ...cardData[cardId], count: cardCounts[cardId] }))
        .filter(card => !isServerCard(card.name));

      const charHTML = GachaUtils.buildCharGridHTML(uniqueCards.map(function(c) {
        return { name: c.name, img: c.role_img, count: cardCounts[c.id] };
      }), { translateName: translateName, getCustomImage: getCustomImage });

      const displayId = privateToPublicID(account.name || '');

      const charString = uniqueCards.map(c => translateName(c.name)).join(',');
      const extendedId = `${displayId}----${serverName}----[${charString}]`;

      const infoItems = [];
      if (detectedServer) infoItems.push(`Server: ${detectedServer}`);
      if (sourceInfo.nickname) infoItems.push(`Nickname: ${sourceInfo.nickname}`);
      if (sourceInfo.crystalLeaves) infoItems.push(`Crystal Leaves: ${sourceInfo.crystalLeaves}`);
      if (sourceInfo.gachaCoupons) infoItems.push(`Card Rate Up Tickets: ${sourceInfo.gachaCoupons}`);
      if (sourceInfo.beginnerCoupons) infoItems.push(`Debut Recruitment Tickets: ${sourceInfo.beginnerCoupons}`);
      const infoString = infoItems.join(' | ');

      card.innerHTML = GachaUtils.buildResultHeaderHTML({ displayId: displayId }) + `
<div class="result-info">${infoString}</div>
<div class="chars-row">
    ${charHTML}
</div>`;

      GachaUtils.wireResultHeaderButtons(card, {
        onCopy: () => copyToClipboard(extendedId),
        onPriceCheck: () => window.showPriceCheck(displayId, extendedId)
      });

      res.appendChild(card);
    });

    renderedCount += nextBatch.length;
    if (renderedCount < allSearchResults.length) {
      GachaUtils.observeLastResultCard(res, resultObserver);
    } else if (hasMoreApiPages && !isLoadingMore) {
      GachaUtils.observeLastResultCard(res, resultObserver);
    }
  }

  async function loadMoreAccounts() {
    if (isLoadingMore) return;
    isLoadingMore = true;

    try {
      const selectedCardIds = [];
      Object.keys(selected).forEach(id => {
        const count = selected[id].count;
        for (let i = 0; i < count; i++) {
          selectedCardIds.push(id);
        }
      });

      const result = await fetchNextBatch(currentSearchParams, selectedCardIds, currentSelectedServer, ACCOUNTS_PER_BATCH, true);

      if (result.filteredAccounts.length === 0) {
        hasMoreApiPages = false;
        isLoadingMore = false;
        return;
      }

      allFilteredAccounts.push(...result.filteredAccounts);
      allSearchResults = allFilteredAccounts;
      currentPage = result.lastPage;
      totalPages = result.totalPages;
      hasMoreApiPages = result.hasMore;

      renderBatch();
    } catch (err) {
      console.error('[Trickcal] Failed to load more accounts:', err);
    }

    isLoadingMore = false;
  }
  
  document.querySelector("#clearBtn")?.addEventListener('click', clearSelection);
  document.querySelector("#searchBtn")?.addEventListener('click', performSearch);
  window.copyToClipboard = copyToClipboard;
  window.showPriceCheck = showPriceCheck;
  initResultObserver();
  initPriceModal();
  loadResources();
})();
